<template>
  <q-form class="license-state-dialog-container center relative scroller">
    <div class="row items-center icon-container">
      <img :src="License_Exclamation_Icon" />
    </div>

    <div class="dialog-title text-center">{{ $t('generic.licenseStates.licenseFailure.title') }}</div>
    <div class="dialog-description text-center">
      <div class="gordita-400-16-r">
        {{ $t('generic.licenseStates.licenseFailure.description') }}
        <a
          :href="supportMailUrl"
          class="link-font text-brand_almost_black"
          >{{ supportMailUrl.split(':')[1] }}</a
        >
      </div>

      <div
        v-if="!isRefreshLicense"
        class="input-container"
      >
        <q-input
          :data-testid="elementsId.dialogs.licenseDialogs.licenseFailureDialog.licenseKeyInput"
          v-model="licenseKey"
          class="license-key-input"
          :label="$t('generic.licenseStates.enterLicenseKey')"
          bg-color="white"
          outlined
          lazy-rules
          input-class="brand_almost_black"
          no-error-icon
          @keypress="handleKeyPress($event)"
        />
      </div>

      <div
        class="button-container"
        :class="{ 'button-padding': isRefreshLicense }"
      >
        <q-spinner-dots
          v-if="licensePending"
          class="text-brand_almost_black"
          style="align-items: center"
          size="4em"
        />
        <q-btn
          :data-testid="elementsId.dialogs.licenseDialogs.licenseFailureDialog.submitButton"
          v-else
          ref="sumbit-button"
          flat
          type="submit"
          rounded
          no-caps
          tabindex="3"
          :disabled="!licenseKey && !isRefreshLicense"
          :class="{ disabled: !licenseKey && !isRefreshLicense }"
          class="submit-button load-key-btn incredi-button-ibx primary-strong enable focus-be-gone"
          :label="isRefreshLicense ? $t('generic.licenseStates.retry') : $t('generic.licenseStates.loadKey')"
          @click.prevent.stop="isRefreshLicense ? refreshLicense(true, license?.key) : submitLicense()"
        />
      </div>
    </div>

    <div class="text-center button-container">
      <q-btn
        :data-testid="elementsId.dialogs.licenseDialogs.licenseFailureDialog.errorDetailsButton"
        v-model="isButtonClicked"
        content-class=" gordita-medium-500-13"
        class="error-details-btn text-center gordita-medium-500-13 text-brand_almost_black focus-be-gone"
        :class="{ 'error-details-open': isButtonClicked }"
        no-wrap
        no-caps
        flat
        :ripple="false"
        @click="isButtonClicked = !isButtonClicked"
      >
        <div>{{ $t('generic.licenseStates.licenseFailure.errorDetails') }}</div>
        <q-icon
          size="24px"
          style="padding-left: 4px"
          :name="isButtonClicked ? 'icon-uil uil-angle-up' : 'icon-uil uil-angle-down'"
        />
      </q-btn>
    </div>

    <div
      :data-testid="elementsId.dialogs.licenseDialogs.licenseFailureDialog.errorDetailsText"
      v-show="isButtonClicked"
      class="error-details-text gordita-400-12 scroller"
    >
      {{ errorDetails }}
    </div>
  </q-form>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { mapGetters } from 'vuex';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import License_Exclamation_Icon from '../../../../assets/images/LicenseStatesDialogs/license-exclamation-icon.svg';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  name: 'LicenseFailureDialog',
  mixins: [licenseDialogMixins],
  props: {
    isRefreshLicense: {
      type: Boolean,
      default: false,
    },
    errorDetails: {
      type: String,
      default: 'unexpected error',
    },
  },
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);

    const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService.selectedCoordinator.value || '' }));
    return { GQL_useLicenseInfoQuery, elementsId };
  },
  data() {
    return {
      License_Exclamation_Icon,
      isButtonClicked: false,
    };
  },
  computed: {
    ...mapGetters({
      enteredLicenseKey: ['settings/enteredLicenseKeyValue'],
    }),
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license;
    },
  },
  created() {
    this.licenseKey = this.enteredLicenseKey || '';
  },
});
</script>

<style scoped lang="scss">
@import './LicenseDialogsCommonStyle';
.button-padding {
  margin-top: 56px;
}
.error-details-btn {
  &:hover,
  &.error-details-open {
    transition: background 0.2s;
    background: $-hovers-hover-error;
  }
  padding: 0 4px 0 8px;
  height: 32px;
  color: $-system-app-error;
  align-items: center;
  line-height: 17px;
}

.error-details-text {
  color: $-text-text-medium;
  background-color: $-system-app-grey-95;
  width: 312px;
  height: 96px;

  max-height: 100%;
  max-width: 100%;
  margin: 8px auto auto auto;
  padding: 12px;
  transition: heightAnimate 0.8s;
}
@keyframes heightAnimate {
  0% {
    height: 0px;
    opacity: 0;
  }
  100% {
    height: 96px;
    opacity: 1;
  }
}
</style>
